module.exports = __webpack_public_path__ + "img/banner-login-001.e82fa0cd.webp";